const FORM_ID = "RqbmuH";
const dialogSelector =
  'div.needsclick.kl-private-reset-css-Xuajs1[role="dialog"]';

window.addEventListener("klaviyoForms", (e) => {
  if (e?.detail?.type === "submit" && e?.detail?.formId === FORM_ID) {
    const interval = setInterval(() => {
      const dialog = document.querySelector(dialogSelector);
      const popup = dialog?.parentElement;
      const innerInput = popup?.querySelector("input#email_85377128");
      if (popup && !innerInput) {
        popup.classList.add("popup_RqbmuH_code_form");
        const containerId = "floating-button-form-container";
        const ls_key = "floating_button_form_closed";
        const container = document.getElementById(containerId);
        const timestamp = new Date().getTime().toString();
        localStorage.setItem(ls_key, timestamp);
        container?.remove();
        clearInterval(interval);
      }
    }, 100);
  }
});
